import dayjs from 'dayjs';
export const toDate = (date, options) => {
    if (!date) {
        return 'N/A';
    }
    switch (options?.preset) {
        case 'short':
            return dayjs(date).format('DD.MM.YYYY');
        case 'short_with_time':
            return dayjs(date).format('DD.MM.YYYY, HH:mm');
        case 'timestamp':
            return dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
        case 'date_struct':
            return dayjs(date).format('YYYY-MM-DD');
        case 'date_struct_with_time':
            return dayjs(date).format('YYYY-MM-DD[T00:00:00Z]');
        case 'full_date':
            return dayjs(date).format('MMMM DD, YYYY');
        case 'full_date_with_time':
            return dayjs(date).format('MMMM DD, YYYY HH:mm');
        default:
            return dayjs(date).format('DD.MM.YYYY');
    }
};
export const toRelativeDateNotation = (notation) => {
    const direction = notation.startsWith('-') ? 'before' : 'after';
    const [, , amount, unit] = notation.match(/^(-)?(\d+)([dwMy])$/) || [];
    return {
        direction,
        unit: unit,
        amount: parseInt(amount, 10),
    };
};
//# sourceMappingURL=datetime.js.map